import React from 'react'
import TruncatedText from './TruncatedText'

function Anchor(props) {
    const { url } = props

    return (
        <a href={ url } target="_blank" className="url-text">
            {
                url.length > 80 ? (
                    <TruncatedText value={ url } length={ 80 } />
                ) : url
            }
        </a>
    )
}

export default Anchor